export const DB_NAME = 'database'
// version 1 with only chatdaddy connector
export const CHAT_THREAD_STORE_NAME = 'chat-threads';
export const CHAT_MESSAGE_STORE_NAME = 'chat-messages';
// version 2 - multi-platform connector
export const PLATFORM_CHAT_THREAD_STORE_NAME = 'platform-chat-threads';
export const PLATFORM_CHAT_MESSAGE_STORE_NAME = 'platform-chat-messages';
export const CUSTOMER_STORE_NAME = 'customers';
export const assetUrl = `${process.env.NEXT_PUBLIC_AWS_SAYZOLO_PUBLIC_BUCKET_URL || ''}/assets`;
